import { render, staticRenderFns } from "./EmailVerified.vue?vue&type=template&id=73227252&scoped=true"
import script from "./EmailVerified.vue?vue&type=script&lang=ts"
export * from "./EmailVerified.vue?vue&type=script&lang=ts"
import style0 from "./EmailVerified.vue?vue&type=style&index=0&id=73227252&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73227252",
  null
  
)

export default component.exports